import React from "react";
import styled, { keyframes } from "styled-components";

const Checkbox = (props) => {

  const {
    value,
    checked,
    onChange,
    name,
    id,
    label,
    disabled
  } = props;

  return (
    <Label htmlFor={id} disabled={disabled}>
      {label}
      <Input
        id={id}
        type="checkbox"
        name={name}
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <Indicator />
    </Label>
  );
}

export default Checkbox;

const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`;

const Label = styled.label`
  position: relative;
  display: inline-block;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  margin: 0.6em 1em 0.6em 0;
  padding-right: 1.5em;
  font-size: 14px;
  font-weight: 500;
`;

const rotate = keyframes`
 from {
    opacity: 0;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(45deg);
  }
`;

const Indicator = styled.div`
  width: 1.2em;
  height: 1.2em;
  background-color: transparent;
  position: absolute;
  top: 0em;
  right: 0em;
  border: 2px solid #A8A8A8;
  border-radius: 0.2em;

  ${Input}:checked + & {
    background-color: var(--primary-one);
    border: 2px solid var(--primary-one);
  }

  ${Label}:hover & {
    border: 2px solid var(--primary-one);
  }

  &::after {
    content: "";
    position: absolute;
    display: none;
  }

  ${Input}:checked + &::after {
    display: block;
    top: 0.1em;
    left: 0.35em;
    width: 25%;
    height: 60%;
    border: solid #fff;
    border-width: 0 0.2em 0.2em 0;
    animation-name: ${rotate};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }
`;
